export default __webpack_public_path__ + "static/plan-BR-1963bd000d9c7b837e7b154a64528d86.png";